export const ServiceTemplates = [
  {
    key: 'httpBin',
    name: 'HTTP Bin: echo request',
    url: 'https://httpbin.org/get',
    method: 'GET',
    headers: [
      { key: 'X-Test-Header', value: 'My test header value', enabled: true },
      { key: 'Accept', value: 'application/json', enabled: true },
      { key: 'User-Agent', value: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36', enabled: true, secret: false },
    ],
    parameters: [
      { key: 'testParameter1', value: 'Hello World!', enabled: true },
      { key: 'testParameter2', value: 'My Test', enabled: true }
    ]
  },
  {
    key: 'weatherReston',
    name: 'weather.gov: Virginia, Reston',
    url: 'https://api.weather.gov/gridpoints/LWX/98,74/forecast',
    method: 'GET',
    headers: [
      { key: 'Accept', value: 'application/geo+json', enabled: true },
      { key: 'User-Agent', value: 'YourAppName/1.0 your-email@example.com', enabled: true, secret: false },
    ],
    parameters: [
    ]
  },
  {
    key: 'gitHubVsCodeIssues',
    name: 'GitHub Public API: VSCode issues',
    url: 'https://api.github.com/repos/microsoft/vscode/issues',
    method: 'GET',
    headers: [
      { key: 'Accept', value: 'application/vnd.github+json', enabled: true },
      { key: 'User-Agent', value: 'YourAppName/1.0 your-email@example.com', enabled: true, secret: false },
    ],
    parameters: [
      { key: 'state', value: 'open', enabled: true },
      { key: 'per_page', value: '10', enabled: true },
    ]
  },
  {
    key: 'nasaOpenApi',
    name: 'NASA Open API',
    url: 'https://api.nasa.gov/planetary/apod',
    method: 'GET',
    headers: [
    ],
    parameters: [
      { key: 'api_key', value: 'DEMO_KEY', enabled: true }
    ]
  }
];
